// graphql endpoint wants iso format (yyyy-mm-dd)
const convertToGqlDateFormat = (date)=>{
    const [year, month, day] = date.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export { convertToGqlDateFormat };
//# sourceMappingURL=convertToGqlDateFormat.js.map
